import { render, staticRenderFns } from "./content-exposure.vue?vue&type=template&id=c20221e8&scoped=true"
import script from "./content-exposure.ts?vue&type=script&lang=ts&external"
export * from "./content-exposure.ts?vue&type=script&lang=ts&external"
import style0 from "./content-exposure.less?vue&type=style&index=0&id=c20221e8&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20221e8",
  null
  
)

export default component.exports